export default __webpack_public_path__ + "static/media/element_48.8f06bb62.jpg";